import { contactCardsData, mapCenter } from "./homeData";
import { heroContent } from "./homeContent";

export const HOME_SEO = {
  title: "ISO Certification Consultancy & Compliance Solutions | MBA Solutions",
  description:
    "MBA Solutions provides professional ISO certification consultancy, food safety solutions, sustainability consulting, ESG services and compliance support to help businesses achieve international standards and improve operational excellence.",
  keywords:
    "ISO certification consultancy, compliance solutions, food safety certification, sustainability consulting, ESG services, textile compliance, supply chain certification, MBA Solutions",
  canonical: "https://mbasolutions.co/",
  ogImage: "https://mbasolutions.co/assets/Logo.webp",
  h1: heroContent.h1,
};

export const buildHomeJsonLd = () => {
  const email = contactCardsData.find((c) => c.label === "Email Us")?.value;
  const phone = contactCardsData.find((c) => c.label === "Call Us")?.value;
  const address = contactCardsData.find((c) => c.label === "Visit Us")?.value;

  return [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "MBA Solutions",
      url: "https://mbasolutions.co",
      logo: "https://mbasolutions.co/assets/Logo.webp",
      description: HOME_SEO.description,
      email,
      telephone: phone,
      address: {
        "@type": "PostalAddress",
        streetAddress: address,
        addressLocality: "Lahore",
        addressCountry: "PK",
      },
      sameAs: [
        "https://www.facebook.com/MBA.Solutions.Official",
        "https://www.linkedin.com/company/64721224/",
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "MBA Solutions",
      image: "https://mbasolutions.co/assets/Logo.webp",
      url: "https://mbasolutions.co",
      telephone: phone,
      email,
      address: {
        "@type": "PostalAddress",
        streetAddress: address,
        addressLocality: "Lahore",
        addressCountry: "PK",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: mapCenter[0],
        longitude: mapCenter[1],
      },
      priceRange: "$$",
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "MBA Solutions",
      url: "https://mbasolutions.co",
    },
  ];
};
